<script setup>
import AuthLayout from '@/Layouts/AuthLayout.vue';
import { Head, usePage } from '@inertiajs/vue3';

const page = usePage()
</script>

<template>
    <AuthLayout>
        <Head title="Log in" />

        <div>
        <h2 v-if="page.props.tenant" class="text-2xl font-bold text-slate-700 mb-2">{{ page.props.tenant.data.name }}</h2>
        <h3 class="text-lg font-bold text-slate-700">Sign in with WEALTH at work</h3>
        </div>
        <a class="p-3 block w-full bg-indigo-600 hover:bg-indigo-500 rounded-md text-center text-slate-100 transition-all duration-300 ease-in-out" href="/sso">
            Sign in
        </a>
    </AuthLayout>
</template>
